'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useCallback } from 'react';
import { FaInstagram } from 'react-icons/fa';
import { LuExternalLink } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';
import type { FacilityData, FacilitySection } from '@/app/_lib/parseFacilities';
import { FacilityIcon } from './FacilityIcons';
interface InteractiveLocationsProps {
  facilitySections: FacilitySection[];
  onFacilityClick: (facility: FacilityData) => void;
  selectedFacility: FacilityData | null;
}
export function InteractiveLocations(t0) {
  const $ = _c(25);
  const {
    facilitySections,
    onFacilityClick,
    selectedFacility
  } = t0;
  let t1;
  if ($[0] !== onFacilityClick) {
    t1 = facility => {
      if (facility.latitude && facility.longitude) {
        onFacilityClick(facility);
        document.getElementById("map-container")?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    };
    $[0] = onFacilityClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleFacilityClick = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== facilitySections || $[3] !== handleFacilityClick || $[4] !== selectedFacility?.name) {
    const allFacilities = facilitySections.flatMap(_temp);
    const corporateFacility = allFacilities.find(_temp2);
    const adultResidentialFacilities = allFacilities.filter(_temp3);
    const elderlyResidentialFacilities = allFacilities.filter(_temp4);
    const columnOneFacilities = [...(corporateFacility ? [corporateFacility] : []), ...adultResidentialFacilities];
    let t7;
    if ($[10] !== handleFacilityClick || $[11] !== selectedFacility?.name) {
      t7 = facility_3 => <button type="button" key={facility_3.name} className={twMerge("rounded-lg border border-l-[6px] bg-white shadow-sm transition-all duration-200 dark:bg-gray-800 w-full text-left", "border-t-gray-200 border-r-gray-200 border-b-gray-200", "dark:border-t-gray-700 dark:border-r-gray-700 dark:border-b-gray-700", facility_3.type === "corporate" && "border-l-indigo-600 hover:border-indigo-600 dark:hover:border-indigo-500", facility_3.type === "adult-residential" && "border-l-teal-500 hover:border-teal-500 dark:hover:border-teal-400", facility_3.type === "elderly-residential" && "border-l-amber-400 hover:border-amber-400 dark:hover:border-amber-300", !["corporate", "adult-residential", "elderly-residential"].includes(facility_3.type) && "border-l-gray-300 hover:border-gray-400 dark:hover:border-gray-500", selectedFacility?.name === facility_3.name && "border-primary dark:border-primary scale-105 shadow-lg", facility_3.latitude && facility_3.longitude && "cursor-pointer hover:scale-105 hover:shadow-md")} onClick={() => handleFacilityClick(facility_3)} disabled={!facility_3.latitude || !facility_3.longitude}><div className="p-4"><div className="flex items-start space-x-3"><div className="mt-1 flex-shrink-0"><FacilityIcon type={facility_3.type} className="h-5 w-5" /></div><div className="flex min-w-0 flex-1 flex-col items-start justify-start"><div className="flex items-center gap-3">{facility_3.website ? <Link href={facility_3.website} className="hover:text-primary dark:hover:text-primary-light inline-flex items-center gap-2 text-lg font-semibold text-black transition-colors duration-150 dark:text-white dark:text-shadow-white" target="_blank" rel="noreferrer" onClick={_temp5}>{facility_3.name} <LuExternalLink className="h-4 w-4" /></Link> : <h4 className="block text-lg font-semibold text-gray-900 dark:text-gray-100">{facility_3.name}</h4>}{facility_3.instagram && <Link href={facility_3.instagram} className="hover:text-primary dark:hover:text-primary-light text-gray-600 transition-colors duration-150 dark:text-gray-400" target="_blank" rel="noreferrer" onClick={_temp6} title="Follow us on Instagram"><FaInstagram className="h-4 w-4" /></Link>}</div><p className="mt-1 text-gray-600 dark:text-gray-300">{facility_3.phone}</p><p className="text-sm text-gray-600 dark:text-gray-400">{facility_3.address ? <span>{facility_3.address}</span> : <span> </span>}</p><p className="text-sm text-gray-600 dark:text-gray-400">{facility_3.license ? <span>{facility_3.license}</span> : <span> </span>}</p>{facility_3.latitude && facility_3.longitude && <p className="hover:text-primary dark:hover:text-primary-light/80 mt-2 inline text-xs text-black dark:text-white">Click to view on map</p>}</div></div></div></button>;
      $[10] = handleFacilityClick;
      $[11] = selectedFacility?.name;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const renderFacilityCard = t7;
    t5 = "grid gap-y-10 md:grid-cols-2 md:gap-x-10 md:gap-y-0";
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{"Corporate Office & Adult Residential Facilities"}</h3>;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t6 = <div className="space-y-6">{t8}{columnOneFacilities.map(facility_4 => renderFacilityCard(facility_4))}</div>;
    t2 = "space-y-6";
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Residential Care Facilities for the Elderly</h3>;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t9;
    if ($[15] !== renderFacilityCard) {
      t9 = facility_5 => renderFacilityCard(facility_5);
      $[15] = renderFacilityCard;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    t4 = elderlyResidentialFacilities.map(t9);
    $[2] = facilitySections;
    $[3] = handleFacilityClick;
    $[4] = selectedFacility?.name;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t7 = <div className={t2}>{t3}{t4}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp6(e_0) {
  return e_0.stopPropagation();
}
function _temp5(e) {
  return e.stopPropagation();
}
function _temp4(facility_2) {
  return facility_2.type === "elderly-residential";
}
function _temp3(facility_1) {
  return facility_1.type === "adult-residential";
}
function _temp2(facility_0) {
  return facility_0.type === "corporate";
}
function _temp(section) {
  return section.facilities;
}